<div class="flex flex-col p-8 text-xl">
	<div class="flex justify-center mt-12 mb-8">
		<div class="flex justify-evenly items-center w-full xl:w-[80%] h-20">
			<div class="h-full">
				<img
					class="h-full"
					src="/assets/images/leap/leap-logo-primary.png"
					alt="Leap logo"
				/>
			</div>
			<div class="h-full flex items-center">
				<img src="/assets/images/leap/link-indicator-arrow.png" />
			</div>
			<div class="h-full px-7">
				<img
					class="h-full"
					src="/assets/images/closer-logos/closer-logo-full.png"
					alt="Closer logo"
				/>
			</div>
		</div>
	</div>
	<div class="mb-10 flex flex-col items-center">
		<h1 class="text-3xl mb-0">
			{{
				leapOnboardingStatus === LeapOnboardingStatus.UserNotOnboarded
					? 'We’re connecting you to ' + ((vm$ | async)?.lawFirmName ?? '')
					: 'Your LEAP Account will be connected to Closer'
			}}
		</h1>
		<p
			class="font-semibold mt-6"
			*ngIf="leapOnboardingStatus === LeapOnboardingStatus.UserNotOnboarded"
		>
			Your profile will be created and linked to this firm in Closer.
		</p>
	</div>

	<ng-container
		*ngIf="
			leapOnboardingStatus === LeapOnboardingStatus.UserNotOnboarded;
			else firmAndUserConfirmationCards
		"
	>
		<div class="flex justify-center mb-8">
			<ui-section
				class="h-full w-7/12"
				[title]="(vm$ | async).lawFirmName"
				subtitle="Law Firm"
				type="section"
			>
				<div
					section-content
					class="grid grid-rows-fit-content grid-cols-[1fr_5fr_9fr] gap-y-3 gap-x-1"
				>
					<app-icon [icon]="ICON.LOCATION"></app-icon>
					<div>Address:</div>
					<div
						class="text-grey-500"
						[innerHTML]="(vm$ | async).lawFirmAddress"
					></div>
					<app-icon [icon]="ICON.PHONE"></app-icon>
					<div>Phone:</div>
					<div class="text-grey-500">{{ (vm$ | async).lawFirmPhone }}</div>
				</div>
			</ui-section>
		</div>
	</ng-container>

	<div class="flex justify-center">
		<ui-button
			classes="mx-3"
			color="secondary"
			label="Cancel"
			(click)="handleCancelClick()"
			[disabled]="isLoading$ | async"
		></ui-button>
		<ui-button
			classes="mx-3"
			label="Connect Now"
			(click)="handleConnectNowClick()"
			[loading]="isLoading$ | async"
			[disabled]="isLoading$ | async"
		></ui-button>
	</div>
</div>

<ng-template #firmAndUserConfirmationCards>
	<div class="grid grid-rows-min auto-rows-min grid-cols-[1fr_1fr] gap-4 mb-8">
		<p class="text-base font-semibold">LEAP Firm connected:</p>

		<p class="text-base font-semibold">LEAP Profile connected:</p>

		<ui-section
			class="h-full"
			[title]="(vm$ | async).lawFirmName"
			subtitle="Law Firm"
			type="section"
		>
			<div
				section-content
				class="grid grid-rows-fit-content grid-cols-[1fr_5fr_9fr] gap-y-3 gap-x-1"
			>
				<app-icon [icon]="ICON.LOCATION"></app-icon>
				<div>Address:</div>
				<div
					class="text-grey-500 break-all"
					[innerHTML]="(vm$ | async).lawFirmAddress"
				></div>
				<app-icon [icon]="ICON.PHONE"></app-icon>
				<div>Phone:</div>
				<div class="text-grey-500 break-all">
					{{ (vm$ | async).lawFirmPhone }}
				</div>
			</div>
		</ui-section>

		<ui-section
			class="h-full"
			[title]="(vm$ | async).userName"
			subtitle="User"
			type="section"
		>
			<div
				section-content
				class="grid grid-rows-fit-content grid-cols-[1fr_5fr_9fr] gap-y-3 gap-x-1"
			>
				<app-icon [icon]="ICON.EMAIL"></app-icon>
				<div>Email:</div>
				<div class="text-grey-500 break-all">{{ (vm$ | async).userEmail }}</div>
				<app-icon [icon]="ICON.PHONE"></app-icon>
				<div>Phone:</div>
				<div class="text-grey-500 break-all">{{ (vm$ | async).userPhone }}</div>
			</div>
		</ui-section>
	</div>
</ng-template>
